// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__iVtI5","logo":"styles_logo__DG9Ru","navigation":"styles_navigation__VWAtR","joinUs":"styles_joinUs__lQ5i9","menuIcon":"styles_menuIcon___Q9Q0"};